import React from "react";
import FloatAnimation from "./floatAnimation";
import { useRef } from "react";

import trash from "../images/trash.svg";
import wasteManagement from "../images/waste-management.svg";
import solarOne from "../images/solar-1.svg";
import water from "../images/water.svg";
import forest from "../images/forest-2.svg";
import greenOne from "../images/green-1.svg";
import picSeventeen from "../images/pic-17.jpg";
// import plantTwentyTwo from "../images/plant-22.jpg";

function Services() {
  let floatTree = useRef(null);
  let floatLeaves = useRef(null);

  FloatAnimation(floatTree);
  FloatAnimation(floatLeaves);

  return (
    <div>
      <section
        data-aos="fade-up"
        data-aos-delay="150"
        data-aos-duration="1500"
        className="heading-section"
      >
        <div className="background services-bg"></div>
        <div className="overlay"></div>
        <div className="content text-center">
          <p className="page-title">Our Services</p>
          <span className="sub-tagline">
            Sustainable solutions for a better planet 🌎
          </span>
        </div>
      </section>

      <section className="our-services">
        <div className="container">
          <div className="eco-intro text-center my-5 position-relative">
            <h2
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-duration="1500"
              className="eco-heading fw-bold"
            >
              What Do We
              <span className="grow-word">Provide?</span>
              <span ref={floatTree} className="tree-icon">
                🌳
              </span>
            </h2>

            <p
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="1500"
              className="eco-subtext mx-auto"
            >
              Discover our range of{" "}
              <span className="highlight">eco-conscious</span> solutions — made
              to help you make smarter, greener choices with every step 🌱.
            </p>
          </div>

          <div
            data-aos="fade-up"
            data-aos-delay="400"
            data-aos-duration="1500"
            className="row"
          >
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <img src={trash} alt="trash.svg" />
                <p> Waste Management</p>
                <p>
                  We reduce environmental harm by promoting recycling,
                  composting, and responsible waste disposal in communities and
                  businesses.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <img src={wasteManagement} alt="waste-management.svg" />
                <p>Plastic Reduction Initiatives</p>
                <p>
                  Our campaigns and partnerships aim to reduce single-use
                  plastics and promote biodegradable alternatives in everyday
                  use.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <img src={solarOne} alt="solar-1.svg" />
                <p>Clean Energy Advocacy</p>
                <p>
                  We support the shift to solar, wind, and other renewable
                  energy sources to reduce carbon emissions and create a greener
                  future.
                </p>
              </div>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="1500"
            className="row"
          >
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <img src={water} alt="water.svg" />
                <p>Water Conservation Projects</p>
                <p>
                  From rainwater harvesting to efficient irrigation, we help
                  communities use water effectively and wisely and protect
                  freshwater sources.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <img src={forest} alt="forest-2.svg" />
                <p>Forest Restoration</p>
                <p>
                  We work to replant native trees, restore degraded land, and
                  revive natural habitats that support biodiversity and climate
                  resilience.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <img style={{}} src={greenOne} alt="green-1.svg" />
                <p>Green Space Development</p>
                <p>
                  We transform urban and rural spaces into eco-friendly zones by
                  planting trees, building community gardens, and supporting
                  local wildlife.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="statistics position-relative py-5 text-light">
        <div
          className="background position-absolute top-0 start-0 w-100 h-100"
          style={{
            zIndex: -1,
            background: `url(${picSeventeen}) center center / cover no-repeat`,
            filter: "brightness(0.85)",
          }}
        ></div>

        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-4 text-center text-md-start mb-4 mb-md-0">
              <div className="headings position-relative px-4 px-md-5 py-4 py-md-5 rounded">
                <p
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1500"
                  className="fw-semibold fst-italic mb-2"
                  style={{
                    fontSize: "clamp(1rem, 2vw, 1.5rem)",
                    color: "rgba(232, 237, 235, 0.9)",
                  }}
                >
                  Small Actions, Big Results
                </p>

                <p
                  data-aos="fade-up"
                  data-aos-delay="200"
                  data-aos-duration="1500"
                  className="fw-bold text-dark"
                  style={{
                    fontSize: "clamp(2.2rem, 4vw, 3rem)",
                    lineHeight: "1.2",
                    letterSpacing: "-0.5px",
                  }}
                >
                  <span
                    className="highlight"
                    style={{
                      background:
                        "linear-gradient(to right, rgb(29,65,48), rgba(29,65,48, 0.8))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontWeight: 800,
                    }}
                  >
                    Eco
                  </span>{" "}
                  Impact
                </p>

                <div
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="1500"
                  className="underline mt-2 mx-auto mx-md-0"
                  style={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "rgb(29,65,48)",
                    borderRadius: "5px",
                    transition: "width 0.4s ease-in-out",
                  }}
                ></div>
              </div>
            </div>

            {/* Rings */}
            <div className="col-12 col-md-8">
              <div className="row g-4 justify-content-center">
                {/* Paper Saved - 75% */}
                <div
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1500"
                  className="col-6 col-lg-6 d-flex flex-column align-items-center"
                >
                  <div className="main">
                    <svg
                      width="120"
                      height="120"
                      role="img"
                      aria-label="Paper Saved 75%"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgba(232,237,235,0.2)"
                        strokeWidth="10"
                        fill="none"
                      />
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgb(29,65,48)"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray="314"
                        strokeDashoffset="78"
                        strokeLinecap="round"
                        transform="rotate(-90 60 60)"
                      />
                      <text
                        x="60"
                        y="65"
                        textAnchor="middle"
                        fontSize="18"
                        fontWeight="600"
                        fill="rgb(29,65,48)"
                      >
                        75%
                      </text>
                    </svg>
                    <p
                      className="mt-3 text-center fw-semibold"
                      // style={{ color: "rgb(29,65,48)" }}
                    >
                      Paper Saved
                    </p>
                  </div>
                </div>

                {/* Carbon Emissions Cut - 60% */}
                <div
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1500"
                  className="col-6 col-lg-6 d-flex flex-column align-items-center"
                >
                  <div className="main">
                    <svg
                      width="120"
                      height="120"
                      role="img"
                      aria-label="Carbon Emissions Cut 60%"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgba(232,237,235,0.2)"
                        strokeWidth="10"
                        fill="none"
                      />
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgb(29,65,48)"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray="314"
                        strokeDashoffset="126"
                        strokeLinecap="round"
                        transform="rotate(-90 60 60)"
                      />
                      <text
                        x="60"
                        y="65"
                        textAnchor="middle"
                        fontSize="18"
                        fontWeight="600"
                        fill="rgb(29,65,48)"
                      >
                        60%
                      </text>
                    </svg>
                    <p
                      className="mt-3 text-center fw-semibold"
                      // style={{ color: "rgb(29,65,48)" }}
                    >
                      Carbon Emissions Cut
                    </p>
                  </div>
                </div>

                {/* Waste Diverted - 85% */}
                <div
                  data-aos="fade-up"
                  data-aos-delay="200"
                  data-aos-duration="1500"
                  className="col-6 col-lg-6 d-flex flex-column align-items-center"
                >
                  <div className="main">
                    <svg
                      width="120"
                      height="120"
                      role="img"
                      aria-label="Waste Diverted 85%"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgba(232,237,235,0.2)"
                        strokeWidth="10"
                        fill="none"
                      />
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgb(29,65,48)"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray="314"
                        strokeDashoffset="47.1"
                        strokeLinecap="round"
                        transform="rotate(-90 60 60)"
                      />
                      <text
                        x="60"
                        y="65"
                        textAnchor="middle"
                        fontSize="18"
                        fontWeight="600"
                        fill="rgb(29,65,48)"
                      >
                        85%
                      </text>
                    </svg>
                    <p
                      className="mt-3 text-center fw-semibold"
                      // style={{ color: "rgb(29,65,48)" }}
                    >
                      Waste Diverted
                    </p>
                  </div>
                </div>

                {/* Renewable Energy Used - 90% */}
                <div
                  data-aos="fade-up"
                  data-aos-delay="200"
                  data-aos-duration="1500"
                  className="col-6 col-lg-6 d-flex flex-column align-items-center"
                >
                  <div className="main">
                    <svg
                      width="120"
                      height="120"
                      role="img"
                      aria-label="Renewable Energy Used 90%"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgba(232,237,235,0.2)"
                        strokeWidth="10"
                        fill="none"
                      />
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgb(29,65,48)"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray="314"
                        strokeDashoffset="31.4"
                        strokeLinecap="round"
                        transform="rotate(-90 60 60)"
                      />
                      <text
                        x="60"
                        y="65"
                        textAnchor="middle"
                        fontSize="18"
                        fontWeight="600"
                        fill="rgb(29,65,48)"
                      >
                        90%
                      </text>
                    </svg>
                    <p
                      className="mt-3 text-center fw-semibold"
                      // style={{ color: "rgb(29,65,48)" }}
                    >
                      Renewable Energy Used
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whyChooseUs">
        <div className="container">
          <div className="eco-why text-center my-5 position-relative">
            <h2
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="1500"
              className="eco-heading fw-bold"
            >
              Why Choose
              <span className="leaf-word">Us?</span>
              <span ref={floatLeaves} className="leaf-icon">
                🍃
              </span>
            </h2>

            <p
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-duration="1500"
              className="eco-subtext mx-auto"
            >
              Discover the perfect blend of{" "}
              <span className="highlight">trust</span>,
              <span className="highlight">innovation</span>, and
              <span className="highlight">eco-conscious</span> values that make
              us stand out from the forest 🌍.
            </p>
          </div>

          <div
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1500"
            className="row"
          >
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <svg
                  height="8vh"
                  width="100%"
                  version="1.1"
                  id="Layer_1"
                  viewBox="0 0 512 512"
                >
                  <path
                    style={{ fill: "#2A5637" }}
                    d="M448.174,293.319c-9.097,0-16.472-7.375-16.472-16.472v-53.809c0-9.097,7.375-16.472,16.472-16.472 s16.472,7.375,16.472,16.472v53.809C464.647,285.944,457.273,293.319,448.174,293.319z"
                  />
                  <path
                    style={{ fill: "#4E7F4B" }}
                    d="M448.174,293.319c-9.097,0-16.472-7.375-16.472-16.472v-53.809c0-9.097,7.375-16.472,16.472-16.472 V293.319z"
                  />
                  <path
                    style={{ fill: "#E56C1E" }}
                    d="M495.527,341.511c-4.216,0-8.432-1.608-11.647-4.825l-18.722-18.722 c-24.022-24.021-60.018-31.63-91.703-19.385c-0.363,0.141-0.732,0.268-1.104,0.382l-108.197,33.21 c-8.696,2.667-17.911-2.217-20.58-10.913c-2.67-8.696,2.217-17.911,10.913-20.58l107.659-33.044 c43.703-16.634,93.215-6.053,126.306,27.038l18.722,18.722c6.433,6.433,6.433,16.862,0,23.295 C503.959,339.904,499.743,341.511,495.527,341.511z"
                  />
                  <path
                    style={{ fill: "#F2BA57" }}
                    d="M447.627,304.466c-22.211-12.916-49.499-15.42-74.171-5.886c-0.363,0.141-0.732,0.268-1.104,0.382 l-108.197,33.21c-8.696,2.667-17.911-2.217-20.58-10.913c-2.67-8.696,2.217-17.911,10.913-20.58l107.659-33.044 c28.253-10.754,58.934-10.133,86.037,0.591l-0.009,36.565L447.627,304.466z"
                  />
                  <path
                    style={{ fill: "#007871" }}
                    d="M465.745,231.823h-36.239c-9.097,0-16.472-7.375-16.472-16.472s7.375-16.472,16.472-16.472h36.239 c9.097,0,16.472,7.375,16.472,16.472S474.843,231.823,465.745,231.823z"
                  />
                  <path
                    style={{ fill: "#489B6D" }}
                    d="M448.174,231.823h-18.668c-9.097,0-16.472-7.375-16.472-16.472s7.375-16.472,16.472-16.472h18.668 V231.823z"
                  />
                  <path
                    style={{ fill: "#91C0F1" }}
                    d="M495.395,507.457c-9.097,0-16.472-7.375-16.472-16.472v-17.57c0-9.097,7.375-16.472,16.472-16.472 c9.097,0,16.472,7.375,16.472,16.472v17.57C511.867,500.082,504.493,507.457,495.395,507.457z"
                  />
                  <path
                    style={{ fill: "#0EABD9" }}
                    d="M495.395,443.765c-9.097,0-16.472-7.375-16.472-16.472v-46.122c0-9.097,7.375-16.472,16.472-16.472 c9.097,0,16.472,7.375,16.472,16.472v46.122C511.867,436.39,504.493,443.765,495.395,443.765z"
                  />
                  <path
                    style={{ fill: "#489B6D" }}
                    d="M351.222,280.06c-25.427-19.622-57.214-32.798-91.925-38.106c-35.367-5.405-73.006-2.45-108.849,8.55 c-35.841,11.001-68.657,29.67-94.901,53.988c-25.757,23.866-44.679,52.607-54.719,83.115c-2.183,6.634,0.054,13.923,5.583,18.191 c25.427,19.622,57.215,32.797,91.925,38.104c11.506,1.759,23.247,2.632,35.093,2.632c24.569,0,49.573-3.76,73.755-11.182 c35.841-11.001,68.658-29.67,94.903-53.988c25.757-23.866,44.679-52.606,54.719-83.115 C358.989,291.617,356.751,284.327,351.222,280.06z"
                  />
                  <path
                    style={{ fill: "#A2CE86" }}
                    d="M352.344,167.207c-11.793-33.779-32.039-65.647-58.55-92.157s-58.378-46.757-92.157-58.55 c-33.153-11.574-67.411-14.826-99.064-9.403c-6.884,1.179-12.276,6.571-13.454,13.454c-5.423,31.657-2.171,65.913,9.403,99.065 c11.793,33.78,32.039,65.647,58.55,92.157c26.51,26.511,58.377,46.757,92.157,58.55c22.725,7.934,45.964,11.957,68.534,11.957 c10.355,0,20.575-0.848,30.532-2.553c6.884-1.179,12.276-6.571,13.454-13.454C367.169,234.615,363.917,200.359,352.344,167.207z"
                  />
                  <path
                    style={{ fill: "#489B6D" }}
                    d="M352.344,167.207c-11.793-33.779-32.039-65.647-58.55-92.157s-58.378-46.757-92.157-58.55 c-33.153-11.574-67.411-14.826-99.064-9.403c-3.546,0.607-6.69,2.338-9.072,4.809c45.595,45.214,162.486,161.197,264.167,262.684 c2.079-2.276,3.535-5.134,4.08-8.318C367.169,234.615,363.917,200.359,352.344,167.207z"
                  />
                  <path
                    style={{ fill: "#A2CE86" }}
                    d="M1.035,398.477c1.049,2.832,2.869,5.387,5.374,7.321c25.427,19.622,57.215,32.797,91.925,38.104 c11.506,1.759,23.247,2.632,35.093,2.632c24.569,0,49.573-3.76,73.755-11.182c35.841-11.001,68.658-29.67,94.903-53.988 c25.757-23.866,44.679-52.606,54.719-83.115c1.028-3.121,1.064-6.385,0.251-9.413L1.035,398.477z"
                  />
                </svg>
                <p>Eco-Friendly Practices</p>
                <p>
                  We prioritize sustainable materials and methods that reduce
                  waste and pollution.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <svg
                  height="8vh"
                  width="100%"
                  version="1.1"
                  id="Layer_1"
                  viewBox="0 0 512.001 512.001"
                >
                  <path
                    style={{ fill: "#91C0F1" }}
                    d="M349.14,30.304l-0.382-0.275c-55.742-40.132-130.573-40.03-186.205,0.253c-55.23,39.989-78.813,110.63-58.685,175.776l2.985,9.663c11.145,36.074,25.521,73.56,43.485,114.6c8.032,18.348,12.332,37.999,12.332,58.406v31.695c0,31.92,25.514,57.53,57.434,57.53h71.93c31.92,0,57.348-25.611,57.348-57.53v-31.695c0-20.404,4.343-40.055,12.375-58.406c17.959-41.029,32.243-78.516,43.394-114.601l2.964-9.382C428.301,141.005,404.645,70.265,349.14,30.304z"
                  />
                  <path
                    style={{ fill: "#D7EDF3" }}
                    d="M256.003,0.001c-32.759-0.035-65.524,10.06-93.45,30.281c-55.23,39.989-78.813,110.63-58.685,175.776l2.985,9.663c11.145,36.074,25.521,73.56,43.485,114.6c8.032,18.348,12.332,37.999,12.332,58.406v31.695c0,31.92,25.514,57.53,57.434,57.53h35.897L256.003,0.001z"
                  />
                  <path
                    style={{ fill: "#489B6D" }}
                    d="M265.259,169.19c-5.345-3.343-12.129-3.343-17.474,0c-36.596,22.893-59.33,65.251-59.33,110.544c0,45.294,22.734,87.652,59.33,110.544c2.673,1.672,5.705,2.507,8.737,2.507c3.032,0,6.064-0.836,8.737-2.507c36.596-22.892,59.329-65.25,59.329-110.544C324.587,234.44,301.855,192.082,265.259,169.19z"
                  />
                  <path
                    style={{ fill: "#A2CE86" }}
                    d="M256.026,166.683c-2.197,0-5.816,0.836-8.489,2.507c-36.596,22.893-59.205,65.251-59.205,110.544c0,45.294,22.548,87.652,59.144,110.544c2.673,1.672,6.355,2.507,8.551,2.507V166.683H256.026z"
                  />
                  <path
                    style={{ fill: "#F5CA47" }}
                    d="M256.026,413.153c-9.098,0-16.475-7.376-16.475-16.475V292.34c0-9.098,7.376-16.475,16.475-16.475c9.098,0,16.475,7.376,16.475,16.475v104.339C272.5,405.778,265.124,413.153,256.026,413.153z"
                  />
                  <path
                    style={{ fill: "#F7F4A3" }}
                    d="M256.026,413.153c-9.098,0-16.475-7.376-16.475-16.475V292.34c0-9.098,7.376-16.475,16.475-16.475V413.153z"
                  />
                  <path
                    style={{ fill: "#4E7F4B" }}
                    d="M256.026,461.479c-9.098,0-16.475,7.376-16.475,16.475v17.573c0,9.098,7.376,16.475,16.475,16.475c9.098,0,16.475-7.376,16.475-16.475v-17.573C272.5,468.855,265.124,461.479,256.026,461.479z"
                  />
                  <path
                    style={{ fill: "#D7EDF3" }}
                    d="M290.073,461.479h-68.095c-9.098,0-16.475,7.376-16.475,16.475c0,9.098,7.376,16.475,16.475,16.475h68.095c9.098,0,16.475-7.376,16.475-16.475C306.548,468.855,299.172,461.479,290.073,461.479z"
                  />
                  <path
                    style={{ fill: "#4E7F4B" }}
                    d="M162.67,388.728v31.695c0,31.92,25.514,57.53,57.434,57.53h71.93c31.92,0,57.348-25.611,57.348-57.53v-31.695c0-4.342,0.209-8.648,0.595-12.916H162.079C162.463,380.08,162.67,384.385,162.67,388.728z"
                  />
                  <g>
                    <path
                      style={{ fill: "#FFFFFF" }}
                      d="M349.382,388.728c0-4.342,0.209-8.648,0.595-12.916H162.079c0.384,4.268,0.591,8.574,0.591,12.916v13.443h186.712V388.728z"
                    />
                    <path
                      style={{ fill: "#FFFFFF" }}
                      d="M163.787,431.824c1.977,9.978,6.51,18.993,12.887,26.359h158.739c6.364-7.366,10.884-16.381,12.855-26.359H163.787z"
                    />
                  </g>
                </svg>
                <p>Education & Awareness</p>
                <p>
                  We guide people with simple, practical steps to live more
                  sustainably every day.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <div className="card">
                <svg
                  height="8vh"
                  width="100%"
                  version="1.1"
                  id="Layer_1"
                  viewBox="0 0 511.999 511.999"
                >
                  <path
                    style={{ fill: "#A2CE86" }}
                    d="M160.346,458.147c-0.522,0-1.047-0.02-1.574-0.059L50.44,450.03c-12.029-0.895-23.224-6.209-31.524-14.964C4.751,420.122,1.6,397.8,11.076,379.519l75.872-146.37c5.321-10.265,17.956-14.271,28.219-8.953c10.265,5.321,14.273,17.956,8.953,28.219l-75.872,146.37c-1.276,2.46-0.851,5.467,1.055,7.478c1.116,1.178,2.624,1.894,4.243,2.014l108.333,8.058c11.529,0.857,20.18,10.9,19.323,22.429C180.383,449.766,171.203,458.147,160.346,458.147z"
                  />
                  <path
                    style={{ fill: "#489B6D" }}
                    d="M139.926,335.926c-9.773,0-18.513-6.879-20.504-16.828l-14.824-74.045l-68.996,30.691c-10.565,4.696-22.937-0.056-27.634-10.619c-4.699-10.563,0.056-22.937,10.619-27.634l92.895-41.321c5.81-2.586,12.478-2.388,18.125,0.533c5.648,2.921,9.662,8.251,10.909,14.484l19.958,99.693c2.269,11.336-5.08,22.367-16.416,24.636C142.671,335.792,141.288,335.926,139.926,335.926z"
                  />
                  <path
                    style={{ fill: "#A2CE86" }}
                    d="M293.151,448.834c-11.54,0-20.906-9.341-20.933-20.887c-0.027-11.561,9.325-20.955,20.887-20.981l164.866-0.371c2.772-0.006,5.24-1.772,6.142-4.392c0.529-1.535,0.466-3.202-0.176-4.695l-42.924-99.789c-4.568-10.621,0.338-22.934,10.958-27.503c10.616-4.568,22.934,0.338,27.503,10.958l42.926,99.791c4.767,11.082,5.228,23.466,1.301,34.87c-6.704,19.469-25.044,32.58-45.635,32.626L293.2,448.832C293.185,448.834,293.167,448.834,293.151,448.834z"
                  />
                  <path
                    style={{ fill: "#489B6D" }}
                    d="M341.662,511.999c-4.566,0-9.163-1.486-13.015-4.55l-79.578-63.279c-4.977-3.957-7.885-9.962-7.905-16.32s2.851-12.38,7.803-16.369l79.181-63.777c9.003-7.253,22.183-5.834,29.435,3.171c7.253,9.004,5.832,22.183-3.171,29.435l-58.809,47.369l59.106,47c9.049,7.196,10.552,20.365,3.356,29.415C353.928,509.291,347.824,511.999,341.662,511.999z"
                  />
                  <path
                    style={{ fill: "#A2CE86" }}
                    d="M367.221,195.917c-7.067,0-13.964-3.578-17.906-10.059L263.65,44.995c-1.44-2.368-4.231-3.567-6.938-2.981c-1.588,0.342-2.981,1.257-3.924,2.578l-63.158,88.387c-6.723,9.406-19.798,11.582-29.203,4.862c-9.406-6.721-11.583-19.797-4.862-29.203l63.156-88.386c7.011-9.814,17.368-16.62,29.16-19.164c20.129-4.342,40.839,4.559,51.541,22.154l85.666,140.862c6.008,9.878,2.869,22.757-7.009,28.763C374.682,194.933,370.928,195.917,367.221,195.917z"
                  />
                  <path
                    style={{ fill: "#489B6D" }}
                    d="M383.18,222.545c-2.41,0-4.829-0.416-7.15-1.259l-95.557-34.728c-10.866-3.95-16.474-15.959-12.524-26.825c3.95-10.866,15.96-16.475,26.825-12.524l70.973,25.793l9.613-74.899c1.471-11.468,11.969-19.575,23.429-18.098c11.468,1.472,19.57,11.962,18.098,23.429l-12.943,100.844c-0.809,6.307-4.441,11.903-9.87,15.211C390.752,221.511,386.979,222.545,383.18,222.545z"
                  />
                </svg>
                <p>Digital Over Physical</p>
                <p>
                  By offering digital solutions, we help cut down on paper use
                  and carbon emissions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
